import React from 'react';
import Icon from '../../../components/AppIcon';

const WelcomeRewards = ({ academicLevel }) => {
  const getRewardDetails = () => {
    if (academicLevel === 'middle-school') {
      return {
        title: 'Bienvenue, Jeune Explorateur !',
        points: 100,
        badge: 'Explorateur Débutant',
        badgeIcon: 'Compass',
        color: 'green',
        unlocks: [
          'Quiz de découverte des métiers',
          'Exploration ludique des filières',
          'Espace famille pour tes parents'
        ]
      };
    } else if (academicLevel === 'high-school') {
      return {
        title: 'Bienvenue, Lycéen Ambitieux !',
        points: 150,
        badge: 'Orienté Objectif',
        badgeIcon: 'Target',
        color: 'blue',
        unlocks: [
          'Quiz d\'orientation approfondi',
          'Recommandations personnalisées',
          'Annuaire des universités',
          'Chat IA pour tes questions'
        ]
      };
    } else if (academicLevel === 'university') {
      return {
        title: 'Bienvenue, Étudiant Universitaire !',
        points: 200,
        badge: 'Académicien',
        badgeIcon: 'Award',
        color: 'purple',
        unlocks: [
          'Recommandations universitaires avancées',
          'Analyse de parcours académique',
          'Connexion avec des conseillers',
          'Ressources de spécialisation'
        ]
      };
    }
    return {
      title: 'Bienvenue !',
      points: 100,
      badge: 'Nouveau Membre',
      badgeIcon: 'Star',
      color: 'blue',
      unlocks: []
    };
  };

  const reward = getRewardDetails();

  const colorClasses = {
    green: 'from-green-400 to-green-600',
    blue: 'from-blue-400 to-blue-600',
    purple: 'from-purple-400 to-purple-600'
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full">
        <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12 text-center">
          {/* Animated Badge */}
          <div className="mb-8 animate-bounce">
            <div
              className={`inline-flex items-center justify-center w-24 h-24 bg-gradient-to-br ${colorClasses?.[reward?.color]} rounded-full shadow-lg`}
            >
              <Icon name={reward?.badgeIcon} size={48} color="#FFFFFF" />
            </div>
          </div>

          {/* Title */}
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {reward?.title}
          </h1>

          {/* Points Earned */}
          <div className="bg-gradient-to-r from-amber-50 to-amber-100 border border-amber-200 rounded-lg p-6 mb-6">
            <div className="flex items-center justify-center gap-3 mb-2">
              <Icon name="Zap" size={32} className="text-amber-500" />
              <span className="text-4xl font-bold text-amber-600">+{reward?.points}</span>
            </div>
            <p className="text-sm font-medium text-amber-700">Points d'Exploration Gagnés</p>
          </div>

          {/* Badge Unlocked */}
          <div className="bg-gradient-to-r from-blue-50 to-purple-50 border border-blue-200 rounded-lg p-6 mb-8">
            <div className="flex items-center justify-center gap-3 mb-2">
              <Icon name="Award" size={28} className="text-blue-600" />
              <span className="text-xl font-bold text-gray-900">{reward?.badge}</span>
            </div>
            <p className="text-sm text-gray-600">Badge Débloqué</p>
          </div>

          {/* Unlocked Features */}
          <div className="text-left mb-8">
            <h3 className="text-lg font-semibold text-gray-900 mb-4 text-center">
              Fonctionnalités Débloquées
            </h3>
            <div className="space-y-3">
              {reward?.unlocks?.map((unlock, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg border border-gray-200"
                >
                  <div className="flex-shrink-0">
                    <Icon name="CheckCircle" size={24} className="text-green-500" />
                  </div>
                  <span className="text-sm font-medium text-gray-700">{unlock}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Loading Animation */}
          <div className="mb-6">
            <div className="flex items-center justify-center gap-2 text-blue-600">
              <div className="w-2 h-2 bg-blue-600 rounded-full animate-pulse" />
              <div className="w-2 h-2 bg-blue-600 rounded-full animate-pulse" style={{ animationDelay: '0.2s' }} />
              <div className="w-2 h-2 bg-blue-600 rounded-full animate-pulse" style={{ animationDelay: '0.4s' }} />
            </div>
            <p className="text-sm text-gray-600 mt-3">
              Préparation de ton tableau de bord personnalisé...
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeRewards;